import React, { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";

const LogManagement = () => {
  const [message, setMessage] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [logToDelete, setLogToDelete] = useState(null);
  
  const userId = localStorage.getItem("idUsuario");
  
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = () => {
    fetch("https://sismoney.com/painel/logs.php")
      .then((response) => response.json())
      .then((res) => {
        const filteredLogs = res.filter((log) => log.idUsuario == userId);
        setLogs(filteredLogs);
        console.log(filteredLogs)
      })
      .catch((error) => console.error("Erro ao buscar logs:", error));
  };

  const confirmDeleteLog = (log) => {
    setLogToDelete(log);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteLog = () => {
    fetch("https://sismoney.com/painel/logs.php", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: logToDelete.id }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          setMessage("Log excluído com sucesso!");
          fetchLogs();
        } else {
          setMessage(`Erro ao excluir log: ${res.message}`);
        }
      })
      .catch((error) => setMessage("Erro ao excluir log: " + error))
      .finally(() => {
        setIsDeleteModalOpen(false);
        setLogToDelete(null);
      });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-white">Logs de Atividades</h2>

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b">
              <th className="p-3">Nome do Empréstimo</th>
              <th className="p-3">Valor</th>
              <th className="p-3">Juros</th>
              <th className="p-3">Data de Pagamento</th>
              <th className="p-3">Usuário</th>
              <th className="p-3">Descrição</th>
              <th className="p-3">Ações</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id} className="border-b hover:bg-gray-100 dark:hover:bg-gray-700">
                <td className="p-3">{log.nome}</td>
                <td className="p-3">{log.valor}</td>
                <td className="p-3">{log.juros}</td>
                <td className="p-3">{log.dataPagamento}</td>
                <td className="p-3">{log.idUsuario}</td>
                <td className="p-3">{log.descricao}</td>
                <td className="p-3">
                  <button
                    onClick={() => confirmDeleteLog(log)}
                    className="bg-red-500 hover:bg-red-600 text-white p-2 rounded-lg flex items-center"
                  >
                    <Trash2 className="w-4 h-4 mr-1" /> Excluir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isDeleteModalOpen && logToDelete && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 w-96">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">Confirmar Exclusão</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              Tem certeza que deseja excluir o log de ID <strong>{logToDelete.id}</strong>?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={handleDeleteLog}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg"
              >
                Confirmar
              </button>
              <button
                onClick={() => setIsDeleteModalOpen(false)}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-lg"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {message && <p className="text-center text-green-600 dark:text-green-400 font-semibold">{message}</p>}
    </div>
  );
};

export default LogManagement;
